export default __webpack_public_path__ + "static/media/welcome.7ea9a7ca.png";